<template>
    <div>
        <Head :title="__(title)" />
        <!-- Start Hero -->
        <section class="relative table w-full py-20 lg:py-24 bg-gray-50 dark:bg-slate-800">
            <div class="container">
                <div class="grid grid-cols-1 text-center mt-10">
                    <h3 class="text-3xl leading-normal font-semibold">{{ kb.title }}</h3>
                    <ul class="list-none mt-6">
                        <li class="inline-block font-semibold mx-5"> <span class=" block">Time :</span> <span class="block">{{ getReadingTime(kb.details) }}</span></li>
                    </ul>
                </div><!--end grid-->
            </div><!--end container-->

        </section><!--end section-->
        <div class="relative">
            <div class="shape absolute right-0 sm:-bottom-px -bottom-[2px] left-0 overflow-hidden z-1 text-white dark:text-slate-900">
                <svg class="w-full h-auto" viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                </svg>
            </div>
        </div>
        <!-- End Hero -->

        <!-- Start Section-->
        <section class="relative md:py-24 py-16">
            <div class="container">
                <div class="grid md:grid-cols-12 grid-cols-1 gap-[30px]">
                    <div class="lg:col-span-8 md:col-span-6">
                        <div class="p-6 rounded-md">
                            <div class="post-details html" v-html="sanitizeHtml(kb.details)"></div>
                        </div>

                    </div>

                    <div class="lg:col-span-4 md:col-span-6">
                        <div class="sticky top-20">

                            <div v-if="random_kb.length">
                                <h5 class="text-lg font-semibold bg-gray-50 dark:bg-slate-800 shadow dark:shadow-gray-800 rounded-md p-2 text-center mt-8">Random</h5>
                                <div class="flex items-center mt-8" v-for="kb in random_kb" :key="kb.id">
                                    <div class="ml-3">
                                        <a href="" class="font-semibold hover:text-indigo-600">{{ kb.title }}</a>
                                        <p v-if="kb.name" class="text-sm text-slate-400">{{ kb.name }}</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div><!--end grid-->
            </div><!--end container-->

            <subscribe />
        </section><!--end section-->
        <!-- End -->
    </div>
</template>
<script>
import Layout from '@/Shared/Landing/Layout'
import Icon from '@/Shared/Icon'
import {Head} from '@inertiajs/inertia-vue3'
import Subscribe from '@/Shared/Landing/Subscribe'
import sanitizeHtml from "sanitize-html";
export default {
    layout: Layout,
    props: {
        kb: Object,
        random_kb: Array,
        types: Array,
    },
    components: {
        Icon,
        Head,
        Subscribe,
    },
    data(){
        return {
            title: this.kb.title,
            author_name: ''
        }
    },
    methods: {
        getReadingTime(text){
            const wpm = 225;
            const words = text.trim().split(/\s+/).length;
            const time = Math.ceil(words / wpm);
            return time+' minute read';
        },
        sanitizeHtml : sanitizeHtml
    },
    created() {

    }
}
</script>
